/* Original lifecycle adapter for merchant-authored VEYRA sections. */
(() => {
  if (window.VeyraModules) return;
  const mounted = new Map();
  function dispose(id) {
    const entry=mounted.get(id);
    if (entry) { entry.cleanup.forEach(fn=>fn()); mounted.delete(id); }
  }
  function mount({id,run}) {
    const scope=document.getElementById('shopify-section-'+id);
    if (!scope) return;
    const current=mounted.get(id);
    if (current?.scope === scope && current.run === run) return;
    dispose(id);
    const cleanup=[];
    const listener = (target,type,fn,options) => {
      if(type==='DOMContentLoaded') { fn.call(target,new Event(type)); return; }
      if(type==='shopify:section:load') return; // A newly rendered script queues its own module.
      target.addEventListener(type,fn,options);
      cleanup.push(()=>target.removeEventListener(type,fn,options));
    };
    const scrollSurface=()=>{const wrapper=document.querySelector('.page-wrapper');return wrapper&&getComputedStyle(wrapper).overflowY==='auto'?wrapper:window;};
    const facade=target=>new Proxy(target,{get(obj,key){
      if(obj===window && (key==='scrollY'||key==='pageYOffset')){const surface=scrollSurface();return surface===window?window.scrollY:surface.scrollTop;}
      if(obj===window && (key==='scrollTo'||key==='scrollBy'))return (...args)=>{const surface=scrollSurface();surface[key](...args);};
      if(key==='addEventListener')return (type,fn,options)=>listener(obj,type,fn,options);
      const value=Reflect.get(obj,key,obj);
      return typeof value==='function'?value.bind(obj):value;
    }});
    const timer=(native,clear)=>(fn,delay,...args)=>{const token=native(fn,delay,...args);cleanup.push(()=>clear(token));return token;};
    const Observer=class extends IntersectionObserver {
      constructor(callback,options){super(callback,options);cleanup.push(()=>this.disconnect());}
    };
    mounted.set(id,{scope,run,cleanup});
    try {
      run({scope,document:facade(document),window:facade(window),setInterval:timer(window.setInterval.bind(window),clearInterval),setTimeout:timer(window.setTimeout.bind(window),clearTimeout),IntersectionObserver:Observer});
      enhance(scope);
    } catch(error) {
      scope.querySelectorAll('.animate-item').forEach(el=>el.classList.add('in-view'));
      console.error('VEYRA module initialization failed:',id,error);
    }
  }
  function enhance(scope) {
    // Make merchant accordion headings keyboard-operable without changing their design.
    scope.querySelectorAll('.c-accordion-title,.faq-question,.faq-header,.js-mf-trigger').forEach(el=>{
      if(!el.matches('button,a,summary')) {
        el.setAttribute('tabindex','0');el.setAttribute('role','button');
        el.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();el.click();}});
      }
    });
  }
  function flush() {
    if(document.readyState==='loading')return;
    const queue=window.veyraModuleQueue || [];
    while(queue.length)mount(queue.shift());
  }
  window.VeyraModules={flush};
  document.addEventListener('shopify:section:unload',event=>dispose(event.detail.sectionId));
  document.addEventListener('shopify:section:load',()=>queueMicrotask(flush));
  document.addEventListener('DOMContentLoaded',flush,{once:true});
  flush();
})();
